import React from 'react';
import PropTypes from 'prop-types';

import { omit } from 'lodash';
import displayName from 'component-lib/displayName';

export default function SingleFieldRow(props) {
    const otherProps = omit(props, 'children', 'styles', 'styleName');

    return (
        <tr {...otherProps}>
            {props.children}
        </tr>
    );
}

SingleFieldRow.displayName = displayName('Forms/InputGroup/SingleFieldRow');

SingleFieldRow.propTypes = {
    children: PropTypes.any.isRequired,
};
